import { render, staticRenderFns } from "./Briefcase.vue?vue&type=template&id=6290b216&scoped=true&"
import script from "./Briefcase.vue?vue&type=script&lang=js&"
export * from "./Briefcase.vue?vue&type=script&lang=js&"
import style0 from "./Briefcase.vue?vue&type=style&index=0&id=6290b216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290b216",
  null
  
)

export default component.exports